import React from 'react';
import GenericList from 'src/shared/genericList';
import { useTranslation } from 'react-i18next';

export default function GroupTypeList() {
  const { t } = useTranslation();
  const columns = [
    { field: 'group_type_id', headerName: 'ID', hide: true },
    {
      field: 'group_type_name',
      headerName: t('GROUP_TYPE_NAME'),
      width: 250,
      editable: true,
    },
    {
      field: 'group_type_order',
      headerName: t('GROUP_TYPE_ORDER'),
      width: 75,
      editable: true,
      flex: 1,
    },
  ];

  return <GenericList objectName={'group-type'} columns={columns} rowId={'group_type_id'} />;
}
